<template>
  <div>
    <div class="c-container pc-2column">
      <!--side-column-->
      <div class="side-column mobile-none">
        <search-pc @reset_params="resetParams" v-bind:search-params="this.searchParams" v-bind:is-signed-in="is_signed_in" v-bind:counts="counts"></search-pc>
      </div>
        <search-mobile @reset_params="resetParams" @change_show="changeShow" v-bind:is-show="isShow" v-bind:search-params="this.searchParams" v-bind:is-signed-in="is_signed_in" v-bind:counts="counts"></search-mobile>

      <!--main-column-->
      <div class="main-column">
        <h1 class="c-bg-midashi u-bg-black u-tx-white">商品一覧</h1>
        <div class="pc-none">
          <div class="search-condition-box">            
            <div>
              <span>
                <img width="12" height="12" class="search-ico" src="/packs/media/images/common/ico-search-6620d0e77d4ca67a4cf0c6ce03579c54.svg">
                絞り込み条件
              </span>
            </div>
            <div class="search-condition-box-text">
              <div v-if="isSearchParamsPresent(this.searchParams)">
                <div v-if="this.searchParams['is_stockable'] == true">在庫: あり</div>
                <div v-if="this.searchParams['keyword'] != ''">キーワード: {{this.searchParams['keyword']}}</div>
                <div v-if="getOtherConditions(searchParams) != null">その他: {{this.getOtherConditions(searchParams)}}</div>
              </div>
              <div v-else>
                指定無し
              </div>
            </div>
          </div>
          <p class="u-tx-right u-search-title" @click="isShow=!isShow"><span class="change-link"><a>さらに絞り込む</a></span></p>
        </div>
        <form>
          <div class="select-flex">
            <div class="select-flex-item order-things">
            <select class="list-select" v-model="sort_key">
              <option value='ranking_total'>人気順</option>
              <option value='id_desc'>通常表示（新着順）</option>
              <option value='id_asc'>通常表示（古い順）</option>
              <option value='price_asc'>価格の安い順</option>
              <option value='price_desc'>価格の高い順</option>
              <option value='ramendb_point'>RDB評価の高い順</option>
            </select></div>
            <div class="select-flex-item display-method">
              <select name="display-style" class="list-select select1" v-model="is_card_list">
                <option value="2" class="select-thumbnail">サムネイル</option>
                <option value="1" class="select-list">一覧</option>
              </select>
              <!--一覧選択時  -->
            </div>
          </div>
        </form>
        <!--pager-area-->
        <div v-if="this.counter >= 0 && this.products.length > 0" class="pager-area u-mb-30">
          <p class="pager-notes">{{this.counts.total}}件</p>
        </div>
        <!--select-->          
        <!--一覧表示時-->
        <template v-if="is_card_list == 1">
          <ul class="c-card-list">
            <template v-for="product in showProducts" :keys="product.id">
              <search-list v-bind:product="product" v-bind:key="product.id" v-bind:is-signed-in="is_signed_in" v-bind:favorited-ids="favorited_ids" v-bind:notified-ids="notified_ids"></search-list>
            </template>            
          </ul>
        </template>
        <!--サムネイル表示時       -->
        <template v-else>
          <ul class="c-card-row item-card">
            <template v-for="product in showProducts" :keys="product.id">
              <search-card v-bind:product="product" v-bind:key="product.id" v-bind:is-signed-in="is_signed_in" v-bind:favorited-ids="favorited_ids" v-bind:notified-ids="notified_ids"></search-card>
            </template>
          </ul>
        </template>
        <infinite-loading :identifier="identifier" @infinite="infiniteHandler" spinner="spiral" ref="InfiniteLoading" >
          <div slot="spinner">ロード中...</div>
          <div slot="no-more">以上です</div>
          <div slot="no-results">検索結果は以上です</div>
        </infinite-loading>        
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import InfiniteLoading from 'vue-infinite-loading';


import SearchPc from "./packs/components/search_pc";
import SearchMobile from "./packs/components/search_mobile";
import SearchCard from "./packs/components/search_card";
import SearchList from "./packs/components/search_list";
import Vue from "vue";

export default {
  props: {
    genre: {
      type: String,
       default: () => "is_stockable"
    },
    keyword: {
      type: String,
       default: () => "true"      
    }
  },
  components: {
    SearchPc,
    SearchMobile,
    SearchCard,
    SearchList
  },
  data: function () {
    return {
      sort_key: "id_desc",
      dataParams: {},
      identifier: 1,
      now_loading: false,
      counter: -1,
      isShow: false,
      products: [],
      showProducts: [],
      is_card_list: 1,
      is_signed_in: true,
      favorited_ids: [],
      notified_ids: [],
      searchParams: {
        is_stockable: true,
        buy_status: [],
        category: [],
        sauce: [],
        taste: [],
        shading: [],
        noodle: [],
        favorite_status: [],
        notify_status: [],
        keyword: "",
      },
      counts: {
        total: 0,
        category: {
          ramen: 0,
          dipping: 0,
          no_soup: 0,
          inspire_ramen: 0,
          inspire_no_soup: 0,
          takumen_labo: 0,
          curry: 0,
          other: 0
        },
        sauce:  {
          "soy": 0,
          "salt": 0,
          "miso": 0,
          "tonkotsu": 0,
          "tonkotsu_soy": 0,
          "seafood_tonkotsu": 0,
          "niboshi": 0,
          "chicken": 0,
          "house": 0,
          "umakara": 0,
          "tantan": 0,
          "unique": 0,
          "merchandise_sets": 0,
        },
        taste: {
          "super_light": 0,
          "light": 0,
          "medium": 0,
          "heavy": 0,
          "super_heavy": 0
        },
        shading: {
          "super_light": 0,
          "light": 0,
          "medium": 0,
          "heavy": 0,
          "super_heavy": 0
        },
        noodle: {
          "super_thin": 0,
          "thin": 0,
          "medium": 0,
          "thick": 0,
          "super_thick": 0
        },
        buy_status: {
          "purchased": 0,
          "pre_purchased": 0
        },
        favorite_status: {
          "favorited": 0,
        },
        notify_status: {
          "notified": 0,
        }                
        
      }
    }
  },
  watch: {
    components: {
      InfiniteLoading
    },
    sort_key: function(val){
      this.sort_product(val)
    },
    products: function(val){
      //console.log(this.products.length)
    },
    searchParams: {
      handler: function(val){

        this.counter = -1
        //this.$refs.InfiniteLoading.stateChanger.reset(); 
        this.identifier += 1
        this.getProduct()
      },
      deep: true
    }
    

  },

  methods: {
    sort_product (val){
      this.now_loading = true
      switch(val){
        case "ranking_total":
          this.products.sort(function(a,b){
              if(a.ranking_total < b.ranking_total) return -1;
              if(a.ranking_total > b.ranking_total) return 1;
              return 0;
          });
          break
        case "id_desc":
          this.products.sort(function(a,b){
              if(a.id > b.id) return -1;
              if(a.id < b.id) return 1;
              return 0;
          });
          break
        case "id_asc":
          this.products.sort(function(a,b){
              if(a.id < b.id) return -1;
              if(a.id > b.id) return 1;
              return 0;
          });
          break
        case "price_asc":
          this.products.sort(function(a,b){
              if(a.price < b.price) return -1;
              if(a.price > b.price) return 1;
              return 0;
          });
          break   
        case "price_desc":
          this.products.sort(function(a,b){
              if(a.price > b.price) return -1;
              if(a.price < b.price) return 1;
              return 0;
          });
          break  
        case "tabelog_point":
          this.products.sort(function(a,b){
              if(a.tabelog_score > b.tabelog_score) return -1;
              if(a.tabelog_score < b.tabelog_score) return 1;
              return 0;
          });
          break       
        case "ramendb_point":
          this.products.sort(function(a,b){
              if(a.ramendb_score > b.ramendb_score) return -1;
              if(a.ramendb_score < b.ramendb_score) return 1;
              return 0;
          });
          break                                      
        default:
      }


      this.showProducts = this.products.slice(0, 15)
      this.identifier += 1
      this.now_loading = false
    },
    toBoolean (data) {
      return data.toLowerCase() === 'true';
    },
    resetParams(){
      this.searchParams = Object.assign({}, this.dataParams)
    },
    changeShow() {
      this.isShow = !this.isShow
    },
    infiniteHandler($state) {
      setTimeout(() => {

        if(this.counter == -1 || this.now_loading == true){
          $state.loaded()
        }
        else{
          if(this.showProducts.length >= this.products.length) {
              // 表示するデータが無くなった場合
              //console.log("status:complete")
              $state.complete()
          } else {
              // 表示するデータがある場合
              //console.log("handler:"+this.showProducts.length)
              this.showProducts = this.products.slice(0, this.showProducts.length + 15)
              $state.loaded()
          }
        }
      }, 500)
    },
    getProduct(){
      this.now_loading = true
      axios
        .get('/api/products.json', {
          params: {
            is_stockable: this.searchParams.is_stockable,
            buy_status: this.searchParams.buy_status ,
            favorite_status: this.searchParams.favorite_status,
            notify_status: this.searchParams.notify_status,
            category: this.searchParams.category,
            sauce: this.searchParams.sauce,
            taste: this.searchParams.taste,
            shading: this.searchParams.shading ,
            noodle: this.searchParams.noodle ,        
            keyword: this.searchParams.keyword 
          }
        }      
        )
        .then(response => {
          this.is_signed_in = response.data.signed_in
          this.products = response.data.products
          this.favorited_ids = response.data.favorited_ids
          this.notified_ids = response.data.notified_ids   

          this.sort_product(this.sort_key)

          this.showProducts = this.products.slice(0, 15)
          this.counter = this.products.length
          this.counts = response.data.counts
          this.now_loading = false


        })
    },
    isSearchParamsPresent(searchParams){
      if(searchParams['is_stockable'] == true){ return true; }
      if(searchParams['keyword'] != ''){ return true; }
      if(searchParams['buy_status'].length > 0){ return true; }
      if(searchParams['favorite_status'].length > 0){ return true; }
      if(searchParams['notify_status'].length > 0){ return true; }
      if(searchParams['category'].length > 0){ return true; }
      if(searchParams['sauce'].length > 0){ return true; }
      if(searchParams['shading'].length > 0){ return true; }
      if(searchParams['noodle'].length > 0){ return true; }
      return false
    },
    getOtherConditions(searchParams){
      const buy_statuses = {purchased: '購入済み', pre_purchased: '未購入商品'};
      const favorite_statuses = {favorited: "登録済み"};
      const notify_statuses = {notified: "登録済み"};

      const categories = {ramen: 'ラーメン', dipping: 'つけ麺', no_soup: 'まぜそば', inspire_ramen: '二郎インスパイア', inspire_no_soup: '二郎インスパイア汁なし', takumen_labo: 'TAKUMEN LABO', curry: 'カレー', other: 'その他'};
      const sauces = {soy: '醤油', salt: '塩', miso: '味噌', tonkotsu: '豚骨', tonkotsu_soy: '豚骨醤油', seafood_tonkotsu: '魚介豚骨', niboshi: '煮干し', chicken: '鶏白湯', house: '家系', umakara: '旨辛', tantan: '担々麺', unique: '個性派', merchandise_sets: 'グッズ・セット'};      
      const tastes = {super_light: '超あっさり', light: 'あっさり', medium: '普通', heavy: 'こってり', super_heavy: '超こってり'};
      const shadings = {super_light: '超薄味', light: '薄味', medium: '普通', heavy: '濃味', super_heavy: '超濃味'};
      const noodles = {super_thin: '極細麺', thin: '細麺', medium: '普通', thick: '太麺', super_thick: '極太麺'};

      let conditions = [];      
      let str = '';

      if(searchParams['buy_status'].length > 0){
        const buy_status_str = searchParams['buy_status'].map(val => buy_statuses[val]).join('、');
        str = '購入済み商品（' + buy_status_str + '）';       
        conditions.push(str);
      }
      if(searchParams['favorite_status'].length > 0){
        const favorite_status_str = searchParams['favorite_status'].map(val => favorite_statuses[val]).join('、');
        str = 'お気に入り商品（' + favorite_status_str + '）';       
        conditions.push(str);
      }
            
      if(searchParams['notify_status'].length > 0){
        const notify_status_str = searchParams['notify_status'].map(val => notify_statuses[val]).join('、');
        str = '入荷通知商品（' + notify_status_str + '）';       
        conditions.push(str);
      }            
      
      if(searchParams['category'].length > 0){
        const category_str = searchParams['category'].map(val => categories[val]).join('、');
        str = '種類（' + category_str + '）';       
        conditions.push(str);
      }

      if(searchParams['sauce'].length > 0){
        const sauce_str = searchParams['sauce'].map(val => sauces[val]).join('、');
        str = '味（' + sauce_str + '）';
        conditions.push(str);
      }

      if(searchParams['taste'].length > 0){
        const taste_str = searchParams['taste'].map(val => tastes[val]).join('、');
        str = 'あっさり/こってり（' + taste_str + '）';
        conditions.push(str);
      }

      if(searchParams['shading'].length > 0){
        const shading_str = searchParams['shading'].map(val => shadings[val]).join('、');
        str = '薄味/濃口（' + shading_str + '）';
        conditions.push(str);
      }

      if(searchParams['noodle'].length > 0){
        const noodle_str = searchParams['noodle'].map(val => noodles[val]).join('、');
        str = '細麺/太麺（' + noodle_str + '）';
        conditions.push(str);
      }

      return conditions.length > 0 ? conditions.join('、') : null
    }
  }, 
 mounted() {
   if(this.genre === "is_stockable"){
     this.searchParams[this.genre] = this.toBoolean(this.keyword);
   }
   else if(["category", "sauce", "taste", "shading", "noodle"].includes(this.genre)){
     this.searchParams["is_stockable"] = false
     this.searchParams[this.genre] = new Array(this.keyword);
   }
   else if(this.genre === "keyword"){
     this.searchParams["is_stockable"] = false
     this.searchParams["keyword"] = this.keyword
   }


    this.dataParams = Vue.util.extend({}, this.searchParams);   
    this.getProduct()
  }

}

</script>

<style scoped>
{

}
</style>
